/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import * as styles from "./Amenities.module.css";
import amenitiesImage from "../../../images/on-going-projects/enchanted/Images/South-East-Corner-Part-Aerial-View-without-legend-Image-3.jpg";
import amenitiesImage1 from "../../../images/on-going-projects/enchanted/Images/1-Clubhouse-Lobby-Image.jpg";
import amenitiesImage2 from "../../../images/on-going-projects/enchanted/Images/1-Multipurpose-Hall-Image.jpg";
import amenitiesImage3 from "../../../images/on-going-projects/enchanted/AMENITIES/3-Indoor-Golf.jpg";
import amenitiesImage4 from "../../../images/on-going-projects/enchanted/AMENITIES/4-Dining.jpg";
import amenitiesImage5 from "../../../images/on-going-projects/enchanted/AMENITIES/5-Mini-Theatre.jpg";
import amenitiesImage6 from "../../../images/on-going-projects/enchanted/AMENITIES/6-Yoga.jpg";
import amenitiesImage7 from "../../../images/on-going-projects/enchanted/AMENITIES/7-karoake.jpg";
import amenitiesImage8 from "../../../images/on-going-projects/enchanted/AMENITIES/8-Gym.jpg";
import amenitiesImage9 from "../../../images/on-going-projects/enchanted/AMENITIES/9-Badminton-Court.jpg";
import amenitiesImage10 from "../../../images/on-going-projects/enchanted/AMENITIES/10-Indoor-Game-Arena.jpg";
import amenitiesImage11 from "../../../images/on-going-projects/enchanted/AMENITIES/11-Creche.jpg";
import amenitiesImage12 from "../../../images/on-going-projects/enchanted/AMENITIES/12-Business-Centre-Overlooking-Pool.jpg";
import amenitiesImage13 from "../../../images/on-going-projects/enchanted/AMENITIES/13-Conference-Room.jpg";
import amenitiesImage14 from "../../../images/on-going-projects/enchanted/AMENITIES/14-Guest-room.jpg";
import arrowImg from "../../../images/on-going-projects/enchanted/Animation-Icons/arrow-img.png";
import arrowImg2 from "../../../images/on-going-projects/enchanted/Animation-Icons/arrow-img-horizontal.png";

function Amenities() {
  const [isVisible, setIsVisible] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const amenitiesRef = useRef(null);
  const observerRef = useRef(null);
  
  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    });
  };

  useEffect(() => {
    if (typeof window !== 'undefined' && typeof IntersectionObserver !== 'undefined' && amenitiesRef.current) {
      observerRef.current = new IntersectionObserver(handleIntersection, {
        threshold: 0.2,
      });
      
      observerRef.current.observe(amenitiesRef.current);
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
      
      // Set initial width
      setWindowWidth(window.innerWidth);
      
      // Add event listener
      window.addEventListener('resize', handleResize);
      
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  const dataArray = [
    {
      floor: "1ST FLOOR",
      heading: "FLOOR YOUR GUESTS WITH DOUBLE THE AWE",
      description:
        "The south-wing clubhouse boasts an enticing range of premium amenities",
      image: amenitiesImage1,
      imageTitle: "DOUBLE-HEIGHT LOBBY",
    },
    {
      floor: "1ST FLOOR",
      heading: "A BEFITTING STAGE FOR EVERY SHADE OF GRAND CELEBRATION",
      description:
        "An Impressive double-height hall for unforgettable events",
      image: amenitiesImage2,
      imageTitle: "MULTIPURPOSE HALL",
    },
    {
      floor: "1ST FLOOR",
      heading: "PERFECT THAT SWING AND BECOME A NUANCED PRO",
      description:
        "Refreshingly indulge in stimulating golf sessions",
      image: amenitiesImage3,
      imageTitle: "STATE-OF-THE-ART INDOOR GOLF SIMULATOR",
    },
    {
      floor: "1ST FLOOR",
      heading: "STAR RATED DINING MADE EFFORTLESSLY ACCESSIBLE",
      description:
        "A refined luxurious dining area for parties and festive gatherings",
      image: amenitiesImage4,
      imageTitle: "MINI MULTIPUPOSE HALL",
    },
    {
      floor: "1ST FLOOR",
      heading: "EXCERCISE YOUR PRIVILEGE TO INDULGENT SPECIAL SCREENINGS",
      description:
        "Recline in plush chairs and enjoy movies",
      image: amenitiesImage5,
      imageTitle: "MINI-THEATRE",
    },
    {
      floor: "1ST FLOOR",
      heading: "LET YOUR MIND, BODY AND SOUL QUIETLY SURRENDER TO THE SOOTHING VIBES",
      description:
        "A calming retreat to transform your mind and body",
      image: amenitiesImage6,
      imageTitle: "YOGA STUDIO",
    },
    {
      floor: "1ST FLOOR",
      heading: "ELEVATE YOUR KARAOKE NIGHTS TO HIGHER NOTES",
      description:
        "Own the mic, enjoy pulsating music with superior audio-visual systems",
      image: amenitiesImage7,
      imageTitle: "KARAOKE ZONE",
    },
    {
      floor: "1ST FLOOR",
      heading: "ACE YOUR FITNESS ROUTINES WITHOUT BREAKING A SWEAT",
      description:
        "A lifetime access to the most advanced gym equipment",
      image: amenitiesImage8,
      imageTitle: "STATE-OF-THE-ART GYM",
    },
    {
      floor: "1ST FLOOR",
      heading: "DOMINATE THE COURT WITH YOUR GAME",
      description:
        "A superior arena to serve, smash and score",
      image: amenitiesImage9,
      imageTitle: "BADMINTON COURT",
    },
    {
      floor: "1ST FLOOR",
      heading: "AN EVERYDAY REMINDER THAT YOU ARE NEVER TOO OLD TO PLAY",
      description:
        "Fun board games, thrilling rock climbing activities and much more",
      image: amenitiesImage10,
      imageTitle: "INDOOR GAME ARENA WITH ROCK CLIMBING",
    },
    {
      floor: "1ST FLOOR",
      heading: "A WELCOME HOME AWAY FROM HOME FOR YOUR PRECIOUS ONES",
      description:
        "A cheerful setting that fosters colourful childhood memories",
      image: amenitiesImage11,
      imageTitle: "CRÈCHE",
    },
    {
      floor: "1ST FLOOR",
      heading: "A SOPHISTICATED POOLSIDE SETTING TO BOOST YOUR PRODUCTIVITY",
      description:
        "An inspiring space in the East-Wing clubhouse for business operations",
      image: amenitiesImage12,
      imageTitle: "BUSINESS CENTRE",
    },
    {
      floor: "1ST FLOOR",
      heading: "SERIOUS BUSINESS DECISIONS NEED A BEFITTING STAGE",
      description:
        "Adroitly refined space in the East-wing clubhouse",
      image: amenitiesImage13,
      imageTitle: "CONFERENCE ROOM WITH PANTRY & HOUSEKEEPING",
    },
    {
      floor: "1ST FLOOR",
      heading: "OFFER YOUR ESTEEMED GUESTS A THICK GENEROUS SLICE OF LUXURY",
      description:
        "Tastefully designed ensuites nestled in the East wing clubhouse",
      image: amenitiesImage14,
      imageTitle: "GUEST ROOM",
    },
  ];

  return (
    <div className={styles.amenities}>
      <div className={styles.amenitiesContainer}>
        {windowWidth > 1024 ? <div className={styles.amenitiesContentTitle}>
          <h1>Amenities</h1>
          <p>
            The ground floor showcases a podium level that has sprawling greens.
          </p>
          <p>
            The podium acts as a tropical retreat which makes it a far cry from
            the bustle of the city.
          </p>
        </div> : <div className={styles.amenitiesContentTitle}>
          <h1>Amenities</h1>
          <p>
            The ground floor showcases a podium level that has sprawling greens.
            The podium acts as a tropical retreat which makes it a far cry from
            the bustle of the city.
          </p>
        </div>}
        <div className={styles.amenitiesContent}>
          <div className={styles.boxContainer}>
            <div className={styles.boxContainerTitle}>OUTDOOR SANCTUARY</div>
            <div className={styles.boxContainerSubTitle}>CENTRAL GARDEN</div>
          </div>
          <div className={styles.amenitiesContentImage} ref={amenitiesRef}>
            <img loading="lazy"  src={amenitiesImage} alt="Amenities" />
          </div>
          {/* Vertical Arrow 1  */}
          <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerVertical +
              " " +
              styles.arrowContainerVertical1 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerTitle}>Floral Garden</span>
            <img loading="lazy"  src={arrowImg} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerNumber}>3</span>
          </div>
          {/* Vertical Arrow 2  */}
          <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerVertical +
              " " +
              styles.arrowContainerVertical2 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerTitle}>Wellness Garden</span>
            <img loading="lazy"  src={arrowImg} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerNumber}>2</span>
          </div>
          {/* Vertical Arrow 3  */}
          <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerVertical +
              " " +
              styles.arrowContainerVertical3 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerTitle}>Pooja Garden</span>
            <img loading="lazy"  src={arrowImg} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerNumber}>1</span>
          </div>
          {/* Vertical Arrow 4  */}
          <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerVertical +
              " " +
              styles.arrowContainerVertical4 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerTitle}>Badminton Court</span>
            <img loading="lazy"  src={arrowImg} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerNumber}>9</span>
          </div>

          {/* Vertical Arrow 5  */}
          <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerVertical +
              " " +
              styles.arrowContainerVertical5 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerTitle}>Basketball Court</span>
            <img loading="lazy"  src={arrowImg} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerNumber}>8</span>
          </div>

          {/* Vertical Arrow 6  */}
          <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerVertical +
              " " +
              styles.arrowContainerVertical6 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerTitle}>
              Elderly Wellness Garden
            </span>
            <img loading="lazy"  src={arrowImg} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerNumber}>6</span>
          </div>

          {/* Vertical Arrow 7  */}
          <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerVertical +
              " " +
              styles.arrowContainerVertical7 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerTitle}>
              Forestry Garden/ Edible Garden
            </span>
            <img loading="lazy"  src={arrowImg} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerNumber}>4</span>
          </div>

          {/* Vertical Arrow 8  */}
          <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerVertical +
              " " +
              styles.arrowContainerVertical8 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerTitle}>
              Multipurpose Lawn
            </span>
            <img loading="lazy"  src={arrowImg} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerNumber}>13</span>
          </div>

          {/* Vertical Arrow 9  */}
          <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerVertical +
              " " +
              styles.arrowContainerVertical9 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerTitle}>
            Scenic Terrace
            </span>
            <img loading="lazy"  src={arrowImg} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerNumber}>14</span>
          </div>

          {/* Horizontal Arrow 1  */}
          {windowWidth > 1024 ? <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerHorizontal +
              " " +
              styles.arrowContainerHorizontal1 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerTitle}>Koi Pond</span>
            <img loading="lazy"  src={arrowImg2} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerNumber}>12</span>
          </div> : <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerHorizontal +
              " " +
              styles.arrowContainerHorizontal1 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerNumber}>12</span>
            <img loading="lazy"  src={arrowImg} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerTitle}>Koi Pond</span>
          </div>}

          {/* Horizontal Arrow 2  */}
          {windowWidth > 1024 ? <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerHorizontal +
              " " +
              styles.arrowContainerHorizontal2 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerTitle}>
              Cool down Relaxation Room
            </span>
            <img loading="lazy"  src={arrowImg2} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerNumber}>11</span>
          </div> : <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerHorizontal +
              " " +
              styles.arrowContainerHorizontal2 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerNumber}>11</span>
            <img loading="lazy"  src={arrowImg} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerTitle}>Cool down Relaxation Room</span>
          </div>}
          {/* Horizontal Arrow 3  */}
          {windowWidth > 1024 ? <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerHorizontal +
              " " +
              styles.arrowContainerHorizontal3 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerTitle}>Outdoor BBQ Area</span>
            <img loading="lazy"  src={arrowImg2} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerNumber}>7</span>
          </div> : <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerHorizontal +
              " " +
              styles.arrowContainerHorizontal3 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerNumber}>7</span>
            <img loading="lazy"  src={arrowImg} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerTitle}>Outdoor BBQ Area</span>
          </div>}

          {/* Horizontal Arrow 4  */}
          {windowWidth > 1024 ? <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerHorizontal +
              " " +
              styles.arrowContainerHorizontal4 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerTitle}>Kids Playground</span>
            <img loading="lazy"  src={arrowImg2} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerNumber}>10</span>
          </div> : <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerHorizontal +
              " " +
              styles.arrowContainerHorizontal4 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >   
            <span className={styles.arrowContainerNumber}>10</span>
            <img loading="lazy"  src={arrowImg} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerTitle}>Kids Playground</span>
          </div>}

          {/* Horizontal Arrow 5  */}
          {windowWidth > 1024 ? <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerHorizontal +
              " " +
              styles.arrowContainerHorizontal5 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerTitle}>Pocket Park</span>
            <img loading="lazy"  src={arrowImg2} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerNumber}>5</span>
          </div>
          : <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerHorizontal +
              " " +
              styles.arrowContainerHorizontal5 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerNumber}>5</span>
            <img loading="lazy"  src={arrowImg} alt="pointer" className={styles.pointerImg} />
            <span className={styles.arrowContainerTitle}>Pocket Park</span>
            </div>}

          {/* Horizontal Arrow 5  */}
          {windowWidth > 1024 ? <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerHorizontal +
              " " +
              styles.arrowContainerHorizontal6 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerTitle}>Scenic Terrace</span>
            <div className={styles.arrowContainerHorizontal6ImgContainer}>
            <img loading="lazy"  src={arrowImg2} alt="pointer" className={styles.pointerImg} />
            </div>
            <span className={styles.arrowContainerNumber}>14</span>
          </div>
          : <div
            className={
              styles.arrowContainer +
              " " +
              styles.arrowContainerHorizontal +
              " " +
              styles.arrowContainerHorizontal6 +
              " " +
              (isVisible ? styles.arrowContainerVisible : "")
            }
          >
            <span className={styles.arrowContainerNumber}>14</span>
            <div className={styles.arrowContainerHorizontal6ImgContainer}>
            <img loading="lazy"  src={arrowImg} alt="pointer" className={styles.pointerImg} />
            </div>
            <span className={styles.arrowContainerTitle}>Scenic Terrace</span>
            </div>}
        </div>
      </div>
      <div className={styles.floorAmenitiesTitle}>
        EXCITING ASPIRATIONAL AMENITIES IN THE FIRST AND SECOND FLOOR
      </div>
      <div className={styles.floorsContentContainer}>
        <div className={styles.carouselContainer}>
          {dataArray.map((item) => (
            <div className={styles.carouselItem}>
              <div className={styles.textContainer}>
                <div className={styles.floorTitle}>{item.floor}</div>
                <div className={styles.floorHeading}>{item.heading}</div>
                <div className={styles.floorDescription}>
                  {item.description}
                </div>
              </div>
              <div className={styles.imageSection}>
                <div className={styles.imageTitle}>{item.imageTitle}</div>
                <div className={styles.imageContainer}>
                  <img loading="lazy"  src={item.image} alt="Amenities" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Amenities;
